"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var React = require("react");
var react_motion_1 = require("react-motion");
/**
 * If the user does not provide an anim function, do a simple fade in
 */
function fadeIn(springValue) {
    return { opacity: springValue };
}
/**
 * Everything inside the AnimDiv will go through a StaggeredMotion
 * or a Motion if there is only one child
 */
var AnimDiv = (function (_super) {
    __extends(AnimDiv, _super);
    function AnimDiv(props) {
        var _this = _super.call(this, props) || this;
        // Default interpolates from 0 to 1        
        _this._springStart = _this.props.springStart ? _this.props.springStart : 0;
        _this._springTarget = _this.props.springTarget ? _this.props.springTarget : 1;
        // Default spring config has a bit of bounce back
        _this._springConfig = {
            stiffness: _this.props.springStiffness ? _this.props.springStiffness : 160,
            damping: _this.props.springDamping ? _this.props.springDamping : 18
        };
        _this._animFunction = _this.props.animFunction || fadeIn;
        return _this;
    }
    /**
     * Do staggered animation of multiple children
     * @param children
     */
    AnimDiv.prototype.renderStaggered = function (children) {
        var _this = this;
        // Initial anim state sets all spring values to springStart
        var startStates = children.map(function (_) {
            return { value: _this._springStart };
        });
        // Given an array of animStates (one for each child) return the animated elements
        var entriesFromAnimState = function (animStates) { return animStates.map(function (springState, i) {
            var element = children[i];
            var newStyle = __assign({}, element.props.style, _this._animFunction(springState.value));
            return React.cloneElement(element, { style: newStyle });
        }); };
        return (React.createElement("div", { style: this.props.style },
            React.createElement(react_motion_1.StaggeredMotion, { defaultStyles: startStates, styles: function (prevStates) { return prevStates.map(function (style, i) {
                    // This does the staggering. First value animates to 1, others to previous value
                    return i === 0
                        ? { value: react_motion_1.spring(_this._springTarget, _this._springConfig) }
                        : { value: react_motion_1.spring(prevStates[i - 1].value, _this._springConfig) };
                }); } }, function (currentStates) { return (React.createElement("div", null, entriesFromAnimState(currentStates))); })));
    };
    /**
     * Animate a single child element. Might be more performant using Motion than using StaggeredMotion
     * @param reactElement
     */
    AnimDiv.prototype.renderSingle = function (reactElement) {
        var _this = this;
        // console.log("### render single");
        return (React.createElement("div", { style: this.props.style },
            React.createElement(react_motion_1.Motion, { defaultStyle: { value: this._springStart }, style: { value: react_motion_1.spring(this._springTarget, this._springConfig) }, onRest: this.props.onRest }, function (springState) {
                var newStyle = __assign({}, reactElement.props.style, _this._animFunction(springState.value));
                return React.cloneElement(reactElement, { style: newStyle });
            })));
    };
    AnimDiv.prototype.render = function () {
        // Have to flatten children. Otherwise they'll be nested
        var children = React.Children.toArray(this.props.children);
        if (children.length > 1) {
            return this.renderStaggered(children);
        }
        else if (children.length == 1) {
            return this.renderSingle(children[0]);
        }
        return null;
        // This works for unit tests, but React-Motion does some weird stuff internally apparently
        // return <div>{this.props.children}</div>;
    };
    return AnimDiv;
}(react_1.Component));
exports.AnimDiv = AnimDiv;
//# sourceMappingURL=AnimDiv.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aaa/animdiv/build/AnimDiv.js
// module id = 702
// module chunks = 1